/**
 * @class
 * @description This class connect to cdn the cdb balancer api and hepls to get data
 * @exports BalancerApiBusinessObject
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Balancer, P2PDefaultSettings } from '../Utils/Constants';
import Utils from '../Utils/Utils';
import Logger from '../Utils/Logger';
export default class BalancerApiBusinessObject {
    constructor(loader) {
        this.p2pProbability = 0;
        this._loader = loader;
    }
    loadBalancerData(accountCode, resource, isLive, updateTime, debug, isDev, applicationCode, originCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = this.getRouteAndFilename(resource);
            Logger.log("Using development environment -> " + isDev);
            //   const isDev = false; 
            const host = isDev ? Balancer.devHost : Balancer.host;
            const req = new XMLHttpRequest();
            let url = host + "/" + accountCode + "/" + (applicationCode ? applicationCode + "/" : "") + "decision";
            url = url.replace("//", "/");
            url = "https://" + url;
            var parameters = {
                "resource": "" + res.route + res.fileName,
                "live": "" + isLive,
                "extended": "" + true,
                "npawPluginInfo": "" + true,
                "originCode": "" + originCode
            };
            req.open('GET', url + Utils.formatParameters(parameters), false);
            req.send();
            if (req.status >= 200 && req.status <= 300) {
                try {
                    this.options = JSON.parse(req.response);
                    this._loader.storage.setSettings(this.options);
                    this.p2pProbability = this.options.p2p.p2pPercentage || P2PDefaultSettings.probability;
                    this._loader.CDNLoader.setSettings(this.options, res.route);
                    this._loader.CDNLoader.startMonitoring();
                    if (this._loader.P2PLoader)
                        this._loader.P2PLoader.setSettings(this.options);
                }
                catch (e) {
                    console.error('Error parsing Balancer API response: ', e);
                }
            }
            if (updateTime > 0) {
                setTimeout(() => { this.loadBalancerData(accountCode, resource, isLive, updateTime, debug == true ? true : false, isDev == true ? true : false, applicationCode, originCode); }, updateTime * 1000);
            }
            if (debug == true) {
                Logger.active = true;
            }
        });
    }
    getRouteAndFilename(stringUrl) {
        const url = new URL(stringUrl);
        const route = url.origin + url.pathname;
        const limit = route.lastIndexOf('/') + 1;
        return {
            route: route.slice(0, limit),
            fileName: route.slice(limit)
        };
    }
}
